// extracted by mini-css-extract-plugin
export default {"container_menu":"Menu_container_menu__t+aZj","list_menu":"Menu_list_menu__ofYa1","img_logo":"Menu_img_logo__rfpz+","body_left":"Menu_body_left__Vrjh4"};